import UnitImage from "common/src/tft-static/UnitImage";
import AdLayout from "../app-core/AdLayout";

type Portal = {
  id: string;
  name: string;
  desc: string;
  odds: number;
  unitId: string;
};

export default function RegionsPage({
  portals,
}: {
  portals: { [portalId: string]: Portal };
}) {
  return (
    <AdLayout>
      <div className="grid grid-cols-3 gap-6 rounded md:w-[900px] pb-4 px-4 py-2 mt-8">
        {Object.values(portals)
          // .sort((p1, p2) => p1.name.localeCompare(p2.name))
          .map((portal) => {
            return (
              <div key={portal.id} className="p-4 flex flex-col gap-2 bg-bg">
                <div className="flex items-center gap-3">
                  {portal.unitId ? (
                    <UnitImage unitId={portal.unitId} size={36} />
                  ) : null}
                  <div className="flex flex-col gap-[3px]">
                    <div className="font-montserrat font-semibold">
                      {portal.name}
                    </div>
                    <div>{portal.odds + "%"}</div>
                  </div>
                </div>
                <div className="leading-tight">{portal.desc}</div>
              </div>
            );
          })}
      </div>
    </AdLayout>
  );
}
